const startingHotjarListener = () => {
  if (window.dataLayer) window.dataLayer.push({ event: 'gtm_load_hotjar' });
};

export {
  startingHotjarListener,
}